import React, { useMemo } from 'react';
import { Row, Col } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import MetaTable from '@dex/bubl-dash/src/lib/components/MetaTable/MetaTable';
import ActivityPanel from '@dex/bubl-dash/src/lib/components/SinglePanels/ActivityPanel';

const PickupAttendanceSingleView: React.FC<any> = (props: any) => {

    const { data } = props;

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <Col
                className={'main'}
            >

                <Panel
                    heading={"PickupAttendance Details"}
                >

                    <MetaTable
                        data={data}
                        columnA={[
                            {
                                label: 'Customer',
                                key: 'owner',
                                format: 'ModelLink'
                            },
                            {
                                label: 'Host',
                                key: 'host',
                                format: 'ModelLink'
                            },
                            {
                                label: "Status",
                                key: "status",
                            }

                        ]}
                        columnB={[
                            {
                                label:"Session Date",
                                key: "sessionDate",
                                format:"date"
                            },
                            { 
                                label:"Session Group",
                                key:"sessionGroup",
                                format: "ModelLink"
                            },
                            { 
                                label: "Joined On",
                                key: "joinedOn",
                                format: 'OnAndBy'
                            }
                        ]}
                        columnC={[

                        ]}
                    />

                </Panel>

            </Col>

            <Col className={'side'}>

                <ActivityPanel parent={data} />

            </Col>

        </Row>

    ), [data]);

}

export default PickupAttendanceSingleView;
